import useSWR from 'swr';

export const useDrugManufacturersByCountry = (country: 'CO' | 'MX' | null | undefined) => {
    // Verifica si country es null o undefined
    const shouldFetch = country !== null && country !== undefined;

    const { data, mutate, isValidating } = useSWR(
        shouldFetch ? `api/free-trial/drug-manufacturers?filters[country]=${country}` : null,
        {
            revalidateOnFocus: false, // No revalidar al recuperar el foco
            dedupingInterval: 180000, // 3 minutos para evitar solicitudes duplicadas
            shouldRetryOnError: false, // No reintentar en caso de error
        },
    );

    return { data, mutate, isValidating };
};
